import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { Currency, TaxType } from "@/gql/graphql";
import { useTranslations } from "use-intl";

type TaxTypeInputProps = Omit<SelectInputProps<any>, "options"> & {
  currency?: Currency;
};

export function TaxTypeInput({ currency, ...props }: TaxTypeInputProps) {
  const t = useTranslations("common.tax_type");

  const options = [
    ...(currency === undefined || currency === Currency.Aud
      ? [{ value: TaxType.Gst, label: t(TaxType.Gst) }]
      : []),
    { value: TaxType.NoGst, label: t(TaxType.NoGst) },
    { value: TaxType.Reimbursement, label: t(TaxType.Reimbursement) },
  ];

  return (
    <SelectInput
      {...props}
      options={[
        {
          label: "Tax type",
          options,
        },
      ]}
    />
  );
}
